import { AxiosResponse } from 'axios'
import BaseService from './base-service'
import { SSOResponseDTO } from '../interfaces/sso-response-dto'

const userService = new BaseService<SSOResponseDTO>()
const UserService = {
  getUserSSO(signal?: AbortSignal): Promise<AxiosResponse<SSOResponseDTO>> {
    const api = process.env.REACT_APP_KEYCLOAK_URL?.trim().replace(/\/+$/, '')
    if (!api) return Promise.reject(new Error('REACT_APP_KEYCLOAK_URL não configurada'))
    return userService.get(`${api}/protocol/openid-connect/userinfo`, undefined, {
      signal,
      timeout: 15000,
      'axios-retry': { retries: 0 },
    })
  },
}
export default UserService
